import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchProviderLanguages = createAsyncThunk(
  "fetchProviderLanguage",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/languages`
    );
    return result;
  }
);

export const fetchLanguageSuggestions = createAsyncThunk(
  "fetchLanguageSuggestions",

  async (res) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/languages?query=${res}&view=search`
    );

    return result;
  }
);

export const fetchAddProviderLanguages = createAsyncThunk(
  "fetchAddProviderLanguages",

  async ({ providerId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/languages`,
      data
    );

    return result;
  }
);

export const fetchDeleteProviderLanguages = createAsyncThunk(
  "fetchDeleteProviderLanguages",

  async ({ providerId, languageId }) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/providers/${providerId}/languages/${languageId}`
    );

    return result;
  }
);
